export default __webpack_public_path__ + "static/media/7777ROUGE.a7477f2f.pdf";